import Cookies from 'js-cookie'

//过期时间8小时
var inFifteenMinutes = new Date(new Date().getTime() + 28800 * 1000);
export function getToken () {
  return Cookies.get('Authorization')
}

export function setToken (token) {
  return Cookies.set('Authorization', token, { expires: inFifteenMinutes })
}

export function removeToken () {
  return Cookies.remove('Authorization')
}

// 过期时间24小时，存储验证码发送次数
var expireTime = new Date(new Date().getTime() + 86400 * 1000);
export function getSendNum () {
  return Cookies.get('sendNum')
}

export function setSendNum (num) {
  return Cookies.set('sendNum', num, { expires: expireTime })
}

// 过期时间8小时，存储unionId
export function getCoUnionId () {
  return Cookies.get('unionId')
}

export function setCoUnionId (value) {
  return Cookies.set('unionId', value, { expires: inFifteenMinutes })
}